<template>
  <b-overlay :show="formShow" rounded="true" :fixed="true" no-fade>
    <b-card>


      <!-- Filters Section -->
      <div class="mb-3 ">
        <b-row class="w-100">
          <b-col cols="12" lg="4">
            <b-form-group label-class="text-left">
              <v-select 
                id="event" 
                v-model="selectedEvent" 
                :options="eventTypes" 
                :reduce="(val) => val" 
                :filterable="true" 
                placeholder="Search by event" 
                @option:selected="selectedEvents" 
                label="title" 
                :clearable="false" 
                input-id="event" 
              />
            </b-form-group>
          </b-col>

          <!-- <b-col cols="12" lg="3">
            <b-form-group label-class="text-left">
              <v-select 
                id="group" 
                v-model="selectedGroup" 
                :options="eventGroups" 
                :reduce="(val) => val" 
                :filterable="true" 
                placeholder="Search by group" 
                @option:selected="filterGroups" 
                label="name" 
                :clearable="false" 
                input-id="group" 
              />
            </b-form-group>
          </b-col> -->

          <b-col cols="12" lg="4">
            <b-form-group label-class="text-left">
              <b-input-group>
                <flat-pickr 
                  :disabled="resultData.tableData && resultData.tableData.length === 0" 
                  placeholder="Select Date Range" 
                  v-model="rangeDate" 
                  onClose="testClose" 
                  class="form-control" 
                  :config="datePickerConfig" 
                />
                <b-input-group-append>
                  <b-button @click="clearDate()" variant="warning">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          

          <!-- <b-col cols="12" lg="3">
            <b-form-group label-class="text-left">
              <v-select 
                id="teacher" 
                v-model="selectedTeacher" 
                :options="eventTeachers" 
                :reduce="(val) => val" 
                :filterable="true" 
                placeholder="Search by Reviewee" 
                @option:selected="filterTeachers" 
                label="name" 
                :clearable="false" 
                input-id="teacher" 
              />
            </b-form-group>
          </b-col> -->

          <b-col cols="12" lg="2">
            <b-form-group label-class="text-left">
              <b-button 
                @click="showArchiveRecords()" 
                variant="warning" 
                block
              >
                {{ archive == 'N' ? 'Include Archived' : 'Hide Archived' }}
              </b-button>
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="2">
            <b-form-group label-class="text-left">
              <b-button 
                block
                class="ml-2" 
                variant="success" 
                @click="downloadPdf()" 
                :disabled="!resultData.tableData || resultData.tableData.length === 0"
              >
                Download PDF
              </b-button>
              
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Shortcut Buttons Row -->
        <b-row class="w-100 mt-1">
          <b-col cols="12" class="d-flex flex-row flex-wrap">
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisWeek">This Week</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisMonth">This Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectLastMonth">Last Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectNextMonth">Next Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisYear">This Year</b-button>
          </b-col>
        </b-row>

        <b-row class="w-100 mt-1">
          <b-col cols="12" class="d-flex justify-content-end">
            <b-form-checkbox switch v-model="isSummaryTable" class="mb-0">
              Summary
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

      <!-- Main Content Row -->
      <b-row class="mt-3">
        <!-- Left Column - Chart -->
        <b-col cols="12" xl="9" lg="9" md="12" sm="12">
          <b-card>
            <b-card-header class="pb-0">
            </b-card-header>
            <b-card-body class="pt-2" v-if="chartData.labels.length > 0">
              <chartjs-component-bar-teacher-chart 
                ref="teacherChart"
                v-if="notFoundHide" 
                :height="400" 
                :data="chartData" 
                :refreshChart="refreshChart" 
                :options="chartDataOptions" 
                :lineLabel="'Company Average'"
              />
              <h3 class="text-center animate__animated animate__fadeIn" v-else>
                {{ notFoundText }}
              </h3>
            </b-card-body>
            <b-card-body v-else class="pt-2">
              <div class="text-center text-muted py-5">
                <p>No data available for the selected criteria</p>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Column - Statistics -->
        <b-col cols="12" xl="3" lg="3" md="12" sm="12">
          <b-card>
            <b-card-header class="pb-0">
            </b-card-header>
            <b-card-body class="pt-2">
              <table class="table table-bordered table-sm statistics-table">
                <tbody class="text-center">
                  <tr>
                    <th class="bg-dark text-white">
                      Total Company Score
                    </th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.totalCompanyScore : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">
                      Company Benchmark
                    </th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.companyBenchmark : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Mean/Average Score</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      <b style="color:red">{{ resultData.statistics ? resultData.statistics.meanScore : 'N/A' }}</b>
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Standard Deviation</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.standardDeviation : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Total Number of Reviews</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.totalNumberOfSurveys : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">
                      Staff Above Average
                    </th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary bg-success font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.staffAboveAverage : 0 }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Staff Below Average</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary bg-warning font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.staffBelowAverage : 0 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>


      <b-row>
        <b-col>
          <div class="d-flex justify-content-end mb-2">
            <b-button variant="success" @click="downloadExcel()"
                :disabled="!selectedEvent || !resultData.tableData || resultData.tableData.length === 0 || download"
              >Export .xlsx</b-button>

            <b-button
              class="ml-1"
              variant="secondary"
              @click="downloadExcelTests()"
              :disabled="!selectedEvent || !resultData.tableData || resultData.tableData.length === 0 || download"
            >Export Tests .xlsx</b-button>
          </div>
        </b-col>
      </b-row>

      <!-- Staff Data Table -->
      <b-row class="mt-4" v-if="resultData.tableData && resultData.tableData.length > 0">
        <b-col cols="12">
          <b-card>
            <b-card-header class="pb-0">
            </b-card-header>
            <b-card-body class="pt-2">
              <div class="table-responsive">
                <table class="table table-bordered table-striped teacher-stats-table">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Reviewee Name</th>
                      <th class="text-center" v-if="isSummaryTable"># test</th>
                      <th class="text-center" v-if="isSummaryTable">Avg Per Test</th>

                      <th class="text-center" v-if="!isSummaryTable">Survey Date</th>
                      <th class="text-center" v-if="!isSummaryTable">Test Score</th>
                      <th v-for="groupName in resultData.groupNames" :key="groupName" class="text-center">{{ groupName }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(staff, index) in resultData.tableData" :key="index">
                      <td class="font-weight-bold">{{ staff.staffName }}</td>
                      <td class="text-center" v-if="isSummaryTable">{{ staff.testCount }}</td>
                      <td class="text-center" v-if="isSummaryTable">{{ staff.avgPerTest }}</td>

                      <td class="text-center" v-if="!isSummaryTable">{{ staff.surveyDate }}</td>
                      <td class="text-center" v-if="!isSummaryTable">{{ staff.testScore }}</td>
                      <td v-for="groupName in resultData.groupNames" :key="groupName" class="text-center">
                        {{ staff[groupName] !== undefined ? staff[groupName] : 'N/A' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <template #overlay v-if="download">
      <div class="text-center">
        <p id="cancel-label"><feather-icon icon="DownloadIcon" /> Report creating please wait...</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { BCol, BRow, BTab, BTabs, BCard, BAlert, BLink, VBModal, VBTooltip, BTooltip } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import ChartjsComponentBarTeacherChart from './charts-components/ChartjsComponentBarTeacherChart.vue';

import store from '@/store';
import reportStoreModule from '../reportStoreModule';
import ImageCropper from '@core/components/image-cropper/ImageCropper.vue';
import { required, alphaNum, email } from '@validations';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component';
import 'cleave.js/dist/addons/cleave-phone.us';
import router from '@/router';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axiosIns from '@/libs/axios';
import _ from 'lodash';
import { t } from '@/@core/libs/i18n/utils';
import { backgroundColor } from 'echarts/lib/theme/dark';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { $themeColors } from '@themeConfig';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BTooltip,

    vSelect,
    Cleave,
    ToastificationContent,
    ImageCropper,
    ValidationProvider,
    ValidationObserver,
    flatPickr,

    ChartjsComponentBarTeacherChart,
  },

  directives: {
    Ripple,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },



  props: ['StatTrigger','selectedSites'],

  data: function() {
    return {
      resultData: {
        tableData: [],
        chartData: [],
        statistics: null,
        groupNames: [],
        chartColour: '#84D0FF',
        surveyTitle: ''
      },
      rangeDate: null,
      filterDateStart: null,
      filterDateEnd: null,
      baseURL: store.state.app.baseURL,
      required,
      alphaNum,
      email,
      dropdownLoading: false,
      download: false,
      formShow: false,
      isSummaryTable: true,
      schools: [],
      selectedSchool: null,
      groups: [],
      allGroupsData: [],
      filteredQuestions: [],
      selectedEvent: null,
      selectedGroup: null,
      selectedTeacher: null,
      archive: 'N',
      ans: null,
      summaryList: null,
      answerTypes: [1, 2, 3, 4, 'Not Observed'],
      eventTypes: [],
      eventGroups: [],
      eventTeachers: [],
      refreshChart: false,
      notFoundText: '',
      notFoundHide: true,
      datePickerConfig: {
        mode: 'range',
        dateFormat: 'd/m/Y',
        locale: { firstDayOfWeek: 1 },
        onChange: (selectedDates) => {
          if (selectedDates && selectedDates.length === 2) {
            this.applySelectedDates(selectedDates[0], selectedDates[1]);
          }
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: '#84D0FF',
            borderColor: 'transparent',
          },
        ],
      },

      chartDataOptions: {
        elements: {
          rectangle: {
            borderWidth: 2,
            borderSkipped: 'bottom',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        legend: {
          display: false,
        },
        lineAt: 3, // Total Avarage line is here
        tooltips: {
          // Updated default tooltip UI
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 8,
          shadowColor: 'rgba(0, 0, 0, 0.25)',
          backgroundColor: $themeColors.light,
          titleFontColor: $themeColors.dark,
          bodyFontColor: $themeColors.dark,
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false,
                color: 'rgba(200, 200, 200, 0.2)',
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
              },
              scaleLabel: {
                display: false,
              },
              ticks: {
                fontColor: '#6e6b7b',
                fontSize: 10,
                crossAlign: 'center',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                color: 'rgba(200, 200, 200, 0.2)',
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
              },
              ticks: {
                min: 0,
                fontColor: '#6e6b7b',
                beginAtZero: true,
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return value;
                  }
                },
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    //this.getReviewResults();
  },

  created() {
    this.setDefaultMonthRange();
  },

  watch: {
    rangeDate: {
      handler: function(val, before) {
        if (val != null) {
          if (val.includes('to')) {
            this.filterDateStart = this.rangeDate.split(' to ')[0];
            this.filterDateEnd = this.rangeDate.split(' to ')[1];

            this.selectedEvents();
          }
        }
      },
    },
    StatTrigger: {
      handler: function(val, before) {
        if (val === 'TeacherStats') {
          this.getReviewResults();
          this.resultData = {
            tableData: [],
            chartData: [],
            statistics: null,
            groupNames: [],
            chartColour: '#84D0FF',
            surveyTitle: ''
          };
        }
      },
      immediate: true,
    },
    selectedSites(newVal, oldVal){
      if(newVal !== oldVal && this.selectedEvent){
        this.selectedEvents();
      }
    },

    isSummaryTable(newVal, oldVal) {
      if (newVal !== oldVal && this.selectedEvent) {
        this.selectedEvents();
      }
    },
  },
  methods: {
    getNamesHidden() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        return userData && userData.hide_names_from_reports === true;
      } catch (e) {
        return false;
      }
    },
    setDefaultMonthRange() {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      const format = d => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };

  this.filterDateStart = format(firstDay);
  this.filterDateEnd = format(lastDay);
  this.rangeDate = this.toUkRange(firstDay, lastDay);

      // Initial data load
      this.selectedEvents();
    },
    setRange(start, end) {
      const format = d => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };
      this.filterDateStart = format(start);
      this.filterDateEnd = format(end);
      this.rangeDate = this.toUkRange(start,end);
      this.selectedEvents();
    },
    toUk(date){
      const d = String(date.getDate()).padStart(2,'0');
      const m = String(date.getMonth()+1).padStart(2,'0');
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    },
    toUkRange(start,end){
      return `${this.toUk(start)} to ${this.toUk(end)}`;
    },
    applySelectedDates(start,end){
      const iso = d=> `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      this.filterDateStart = iso(start);
      this.filterDateEnd = iso(end);
      this.rangeDate = this.toUkRange(start,end);
      this.selectedEvents();
    },
    selectThisWeek() {
      const now = new Date();
      const dayOfWeek = (now.getDay() + 6) % 7;
      const monday = new Date(now);
      monday.setDate(now.getDate() - dayOfWeek);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      this.setRange(monday, sunday);
    },
    selectThisMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0));
    },
    selectLastMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth() - 1, 1), new Date(now.getFullYear(), now.getMonth(), 0));
    },
    selectNextMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth() + 1, 1), new Date(now.getFullYear(), now.getMonth() + 2, 0));
    },
    selectThisYear() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), 0, 1), new Date(now.getFullYear(), 11, 31));
    },
    showArchiveRecords() {
      if (this.archive == 'Y') {
        this.archive = 'N';

        this.selectedEvents();
      } else {
        this.archive = 'Y';

        this.selectedEvents();
      }
    },

    downloadPdf() {
      this.formShow = true;
      this.download = true;
      
      // Get chart image data
      let chartImageData = null;
      try {
        // Try to get the chart canvas from the chart component
        if (this.$refs.teacherChart && this.$refs.teacherChart.$el) {
          const canvas = this.$refs.teacherChart.$el.querySelector('canvas');
          if (canvas) {
            chartImageData = canvas.toDataURL('image/png');
          }
        }
      } catch (error) {
        console.warn('Could not capture chart image:', error);
      }

      // Format date range for display
      let datePeriod = 'All Time';
      if (this.filterDateStart && this.filterDateEnd) {
        const startDate = new Date(this.filterDateStart);
        const endDate = new Date(this.filterDateEnd);
        datePeriod = `${startDate.toDateString()} to ${endDate.toDateString()}`;
      }

      // Prepare the data from your component
      const reportData = {
        tableData: this.resultData.tableData,
        chartData: this.resultData.chartData,
        statistics: this.resultData.statistics,
        groupNames: this.resultData.groupNames,
        surveyTitle: this.resultData.surveyTitle || this.selectedEvent?.title || 'Staff Statistics Report',
        chartColour: this.resultData.chartColour,
        chartImage: chartImageData,
        datePeriod: datePeriod,
        selectedEvent: this.selectedEvent,
        archive: this.archive
      };

      // Make the API call
      axiosIns.post('reports/download-staff-breakdown-pdf', reportData, {
        responseType: 'blob'
      })
      .then(response => {
        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'staff-breakdown-report.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            text: '📊 Staff Breakdown Report downloaded successfully!',
            icon: 'DownloadIcon',
            variant: 'success',
          },
        });
      })
      .catch(error => {
        console.error('PDF download error:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: 'Failed to generate PDF report',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      })
      .finally(() => {
        this.download = false;
        this.formShow = false;
      });
    },

    // Download Excel export (CT / Staff Results Breakdown)
    downloadExcel() {
      if (!this.selectedEvent || !this.selectedEvent.id || this.download) return;
      this.formShow = true;
      this.download = true;

      // Build teacher filter if selected
      let teacherFilter = null;
      if (this.selectedTeacher && this.selectedTeacher !== 'All Reviewee') {
        try {
          const teacherEmail = this.selectedTeacher.substring(this.selectedTeacher.indexOf('(') + 1, this.selectedTeacher.lastIndexOf(')'));
          const teacherName = this.selectedTeacher.split('-')[0];
          const teacherSurname = this.selectedTeacher.substring(this.selectedTeacher.indexOf('-') + 1, this.selectedTeacher.lastIndexOf('('));
          teacherFilter = {
            teacherEmail: teacherEmail || null,
            teacherFirstName: teacherName || null,
            teacherLastName: teacherSurname || null,
          };
        } catch (e) {
          // silent parse fail
        }
      }

      const payload = {
        eventId: this.selectedEvent.id,
        archive: this.archive,
        namesHidden: this.getNamesHidden(),
        startDate: this.filterDateStart,
        endDate: this.filterDateEnd,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
        group: this.selectedGroup && this.selectedGroup !== 'All Group' ? this.selectedGroup.name : null,
        teacher: teacherFilter,
      };

      store.dispatch('report/exportCtResultsBreakdown', payload)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'staff-breakdown-report.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Excel Exported',
              text: 'Staff breakdown Excel file downloaded successfully.',
              icon: 'DownloadIcon',
              variant: 'success',
            },
          });
        })
        .catch(error => {
          console.error('Excel export error:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Export Failed',
              text: 'Unable to generate Excel file. Please try again later.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          this.download = false;
          this.formShow = false;
        });
    },

    // Download Excel export (CT / Staff Results Tests)
    downloadExcelTests() {
      if (!this.selectedEvent || !this.selectedEvent.id || this.download) return;
      this.formShow = true;
      this.download = true;

      const toUkDate = (value) => {
        if (!value || typeof value !== 'string') return value;
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return value;
        const [, y, m, d] = match;
        return `${d}/${m}/${y}`;
      };

      // Build teacher filter if selected
      let teacherFilter = null;
      if (this.selectedTeacher && this.selectedTeacher !== 'All Reviewee') {
        try {
          const teacherEmail = this.selectedTeacher.substring(this.selectedTeacher.indexOf('(') + 1, this.selectedTeacher.lastIndexOf(')'));
          const teacherName = this.selectedTeacher.split('-')[0];
          const teacherSurname = this.selectedTeacher.substring(this.selectedTeacher.indexOf('-') + 1, this.selectedTeacher.lastIndexOf('('));
          teacherFilter = {
            teacherEmail: teacherEmail || null,
            teacherFirstName: teacherName || null,
            teacherLastName: teacherSurname || null,
          };
        } catch (e) {
          // silent parse fail
        }
      }

      const payload = {
        eventId: this.selectedEvent.id,
        archive: this.archive,
        namesHidden: this.getNamesHidden(),
        filterDate: {
          startDate: toUkDate(this.filterDateStart),
          endDate: toUkDate(this.filterDateEnd),
        },
        teacher: teacherFilter,
      };

      store.dispatch('report/exportCtResultsTests', payload)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'staff-results-tests-report.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Excel Exported',
              text: 'Staff results tests Excel file downloaded successfully.',
              icon: 'DownloadIcon',
              variant: 'success',
            },
          });
        })
        .catch(error => {
          console.error('Excel export tests error:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Export Failed',
              text: 'Unable to generate tests Excel file. Please try again later.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          this.download = false;
          this.formShow = false;
        });
    },

    getLastEvent() {
      this.formShow = true;
      store
        .dispatch('report/getLastEventItem', [])
        .then((res) => {
          if (res.data) {
            this.selectedEvent = res.data;
            this.selectedEvents(res.data);
          }
        })
        .catch((error) => {
          console.log(error);
          this.formShow = false;
        });
    },
    clearDate() {
      if (this.rangeDate != null && this.rangeDate != '') {
        this.filterDateStart = null;
        this.filterDateEnd = null;
        this.rangeDate = null;
        this.selectedEvents();
      }
    },
    filterBySchool() {
      this.selectedEvents(undefined);
    },
    getReviewResults() {
      this.formShow = true;

      let filter = {
        event: this.selectedEvent ? this.selectedEvent : null,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };

      store
        .dispatch('report/getAllReviewResults', filter)
        .then((res) => {

          if(res.data.length > 0){
            
            this.summaryList = res.data[0].summary;
          this.totalRows = res.data.length;
          this.getLastEvent();
          res.data.forEach((element) => {
            this.eventTypes.push(element.event);
          });

          this.eventTypes = _.uniqBy(this.eventTypes, function(e) {
            return e.id;
          });
          }

          this.formShow = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    filterGroups(group) {
      let teacherEmail = null;
      let teacherName = null;
      let teacherSurname = null;

      let filterTeacher = null;

      if (this.selectedTeacher != '' && this.selectedTeacher != undefined && this.selectedTeacher != null) {
        teacherEmail = this.selectedTeacher.substring(this.selectedTeacher.indexOf('(') + 1, this.selectedTeacher.lastIndexOf(')'));
        teacherName = this.selectedTeacher.split('-')[0];
        teacherSurname = this.selectedTeacher.substring(this.selectedTeacher.indexOf('-') + 1, this.selectedTeacher.lastIndexOf('('));

        filterTeacher = {
          teacherEmail: teacherEmail ? teacherEmail : null,
          teacherFirstName: teacherName ? teacherName : null,
          teacherLastName: teacherSurname ? teacherSurname : null,
        };
      }

      let filter = {
        // group: group == undefined ? this.selectedGroup : group.name,

        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        isSummaryTable: this.isSummaryTable,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
        group: this.selectedGroup && this.selectedGroup !== 'All Group' ? this.selectedGroup.name : null,
        teacher: filterTeacher,
        event: this.selectedEvent,
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };

      store
        .dispatch('report/getCTResultsGruopId', filter)
        .then((res) => {
          if (res.data && res.data.data) {
            this.resultData = res.data.data;

            this.chartData.labels = [];
            this.chartData.datasets[0].data = [];

            if (this.resultData.chartData && this.resultData.chartData.length > 0) {
              const generateColors = (count) => {
                const colors = [];
                const baseColors = [
                  '#84D0FF', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
                  '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE',
                  '#85C1E9', '#F8C471', '#82E0AA', '#F1948A', '#85C1E9'
                ];
                for (let i = 0; i < count; i++) {
                  if (i < baseColors.length) colors.push(baseColors[i]);
                  else {
                    const hue = (i * 137.508) % 360;
                    colors.push(`hsl(${hue}, 70%, 65%)`);
                  }
                }
                return colors;
              };

              const barColors = generateColors(this.resultData.chartData.length);
              this.resultData.chartData.forEach((item) => {
                this.chartData.labels.push(item.revieweeName || item.reviewerName || '');
                this.chartData.datasets[0].data.push(item.revieweeAverage ?? item.reviewerAverage ?? 0);
              });
              this.chartData.datasets[0].backgroundColor = barColors;
              this.chartData.datasets[0].borderColor = barColors.map(color => color);

              if (this.resultData.statistics) {
                this.chartDataOptions.lineAt = this.resultData.statistics.meanScore;
                this.chartData.datasets[0].totalAvarage = this.resultData.statistics.meanScore;
              }

              this.notFoundHide = true;
            } else {
              this.notFoundHide = false;
              this.notFoundText = 'No data found';
            }

            this.refreshChart = !this.refreshChart;
            this.formShow = false;

            this.schools = [];
            this.schools.push('All School');

            this.eventGroups = [];
            this.eventGroups.push('All Groups');

            this.eventTeachers = [];
            this.eventTeachers.push('All Reviewee');

            if (res.data.data.teachers != undefined) {
              res.data.data.teachers.forEach((t) => {
                this.eventTeachers.push(t);
              });
            }

            if (res.data.data.groups != undefined) {
              res.data.data.groups.forEach((g) => {
                this.eventGroups.push(g);
              });
            }

            if (res.data.data.schools != undefined) {
              res.data.data.schools.forEach((s) => {
                this.schools.push(s.schoolName);
              });
            }
          }
        })
        .catch((error) => {
          this.formShow = false;
          console.log(error);
        });
    },

    filterTeachers(teacher) {
      let teacherEmail = null;
      let teacherName = null;
      let teacherSurname = null;

      let filterTeacher = null;

      if (this.selectedTeacher != '' && this.selectedTeacher != undefined && this.selectedTeacher != null) {
        teacherEmail = teacher.substring(teacher.indexOf('(') + 1, teacher.lastIndexOf(')'));
        teacherName = this.selectedTeacher.split('-')[0];
        teacherSurname = teacher.substring(teacher.indexOf('-') + 1, teacher.lastIndexOf('('));

        filterTeacher = {
          teacherEmail: teacherEmail ? teacherEmail : null,
          teacherFirstName: teacherName ? teacherName : null,
          teacherLastName: teacherSurname ? teacherSurname : null,
        };
      }

      let filter = {
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        isSummaryTable: this.isSummaryTable,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
        group: this.selectedGroup && this.selectedGroup !== 'All Group' ? this.selectedGroup.name : null,
        teacher: filterTeacher,
        event: this.selectedEvent,
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };

      store
        .dispatch('report/getCTResultsByTeacher', filter)
        .then((res) => {
          if (res.data && res.data.data) {
            this.resultData = res.data.data;

            this.chartData.labels = [];
            this.chartData.datasets[0].data = [];

            if (this.resultData.chartData && this.resultData.chartData.length > 0) {
              const generateColors = (count) => {
                const colors = [];
                const baseColors = [
                  '#84D0FF', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
                  '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE',
                  '#85C1E9', '#F8C471', '#82E0AA', '#F1948A', '#85C1E9'
                ];
                for (let i = 0; i < count; i++) {
                  if (i < baseColors.length) colors.push(baseColors[i]);
                  else {
                    const hue = (i * 137.508) % 360;
                    colors.push(`hsl(${hue}, 70%, 65%)`);
                  }
                }
                return colors;
              };

              const barColors = generateColors(this.resultData.chartData.length);
              this.resultData.chartData.forEach((item) => {
                this.chartData.labels.push(item.revieweeName || item.reviewerName || '');
                this.chartData.datasets[0].data.push(item.revieweeAverage ?? item.reviewerAverage ?? 0);
              });

              this.chartData.datasets[0].backgroundColor = barColors;
              this.chartData.datasets[0].borderColor = barColors.map(color => color);

              if (this.resultData.statistics) {
                this.chartDataOptions.lineAt = this.resultData.statistics.meanScore;
                this.chartData.datasets[0].totalAvarage = this.resultData.statistics.meanScore;
              }

              this.notFoundHide = true;
            } else {
              this.notFoundHide = false;
              this.notFoundText = 'No data found';
            }

            this.refreshChart = !this.refreshChart;
            this.formShow = false;
          }

          if (this.chartData.datasets[0].data.length > 0) {
            this.notFoundHide = true;
            this.refreshChart = !this.refreshChart;
          } else {
            this.notFoundHide = false;
            this.notFoundText = 'No data found in this group';
          }

          //Calculate total avarage score
          this.chartData.datasets[0].totalAvarage = (_.sum(totalAvaragesArray) / totalAvarageObserversCount).toFixed(2);
          //total avarage equal to line
          this.chartDataOptions.lineAt = this.chartData.datasets[0].totalAvarage;

          this.schools = [];
          this.schools.push('All School');

          if (res.data.data.schools != undefined) {
            res.data.data.schools.forEach((s) => {
              this.schools.push(s.schoolName);
            });
          }

          this.eventGroups = [];

          this.eventGroups.push('All Groups');

          if (res.data.data.groups != undefined) {
            res.data.data.groups.forEach((g) => {
              this.eventGroups.push(g);
            });
          }

          // this.eventTeachers = [];

          // this.eventTeachers.push('All CT');

          // if (res.data.data.teachers != undefined) {
          //   res.data.data.teachers.forEach((t) => {
          //     this.eventTeachers.push(t);
          //   });
          // }
        })
        .catch((error) => {
          this.formShow = false;
          console.log(error);
        });
    },

    selectedEvents(event) {
      if (event != undefined) {
        this.selectedSchool = null;
        this.selectedGroup = null;
        this.selectedTeacher = 'All Reviewee';
      }

      let teacherEmail = null;
      let teacherName = null;
      let teacherSurname = null;

      let filterTeacher = null;

      if (this.selectedTeacher != '' && this.selectedTeacher != undefined && this.selectedTeacher != null) {
        teacherEmail = this.selectedTeacher.substring(this.selectedTeacher.indexOf('(') + 1, this.selectedTeacher.lastIndexOf(')'));
        teacherName = this.selectedTeacher.split('-')[0];
        teacherSurname = this.selectedTeacher.substring(this.selectedTeacher.indexOf('-') + 1, this.selectedTeacher.lastIndexOf('('));

        filterTeacher = {
          teacherEmail: teacherEmail ? teacherEmail : null,
          teacherFirstName: teacherName ? teacherName : null,
          teacherLastName: teacherSurname ? teacherSurname : null,
        };
      }

      let filter = {
        event: event == undefined ? this.selectedEvent : event,
        // group: group == undefined ? this.selectedGroup : null,
        // teacher: teacher == undefined ? this.selectedTeacher : null,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        isSummaryTable: this.isSummaryTable,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
        group: this.selectedGroup && this.selectedGroup !== 'All Group' ? this.selectedGroup.name : null,
        teacher: filterTeacher,
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };

      store
        .dispatch('report/getCTResultsEventId', filter)
        .then((res) => {
          // Handle new API response format
          if (res.data && res.data.data) {
            this.resultData = res.data.data;
            
            // Update chart data
            this.chartData.labels = [];
            this.chartData.datasets[0].data = [];
            
            if (this.resultData.chartData && this.resultData.chartData.length > 0) {
              // Generate different colors for each bar
              const generateColors = (count) => {
                const colors = [];
                const baseColors = [
                  '#84D0FF', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', 
                  '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE',
                  '#85C1E9', '#F8C471', '#82E0AA', '#F1948A', '#85C1E9'
                ];
                
                for (let i = 0; i < count; i++) {
                  if (i < baseColors.length) {
                    colors.push(baseColors[i]);
                  } else {
                    // Generate additional colors if needed
                    const hue = (i * 137.508) % 360; // Golden angle approximation
                    colors.push(`hsl(${hue}, 70%, 65%)`);
                  }
                }
                return colors;
              };

              const barColors = generateColors(this.resultData.chartData.length);
              
              this.resultData.chartData.forEach((item, index) => {
                this.chartData.labels.push(item.revieweeName);
                this.chartData.datasets[0].data.push(item.revieweeAverage);
              });
              
              // Set different colors for each bar
              this.chartData.datasets[0].backgroundColor = barColors;
              this.chartData.datasets[0].borderColor = barColors.map(color => color);
              
              // Set line for company average using the plugin (lineAt)
              if (this.resultData.statistics) {
                this.chartDataOptions.lineAt = this.resultData.statistics.meanScore;
                this.chartData.datasets[0].totalAvarage = this.resultData.statistics.meanScore;
              }

              this.notFoundHide = true;
            } else {
              this.notFoundHide = false;
              this.notFoundText = 'No data found';
            }
            
            this.refreshChart = !this.refreshChart;
            this.formShow = false;

            // Update dropdowns if available
            this.schools = [];
            this.schools.push('All School');

            this.eventGroups = [];
            this.eventGroups.push('All Groups');

                         this.eventTeachers = [];
             this.eventTeachers.push('All Reviewee');
          }

          if (res.data.data.teachers != undefined) {
            res.data.data.teachers.forEach((t) => {
              this.eventTeachers.push(t);
            });
          }
        })
        .catch((error) => {
          this.formShow = false;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.left-align .nav-tabs .nav-link {
  justify-content: left !important;
}

.teacher-stats-table {
  font-size: 0.9rem;
  
  thead th {
    background-color: #343a40 !important;
    color: white !important;
    font-weight: 600;
    border-color: #454d55 !important;
  }
  
  tbody td {
    vertical-align: middle;
    border-color: #dee2e6;
  }
  
  .font-weight-bold {
    font-weight: 600;
  }
}

.statistics-table {
  width: 100%;
  
  th {
    background-color: #343a40 !important;
    color: white !important;
    font-weight: 600;
    border: 1px solid #454d55;
    padding: 8px 12px;
  }
  
  td {
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6;
    padding: 8px 12px;
    font-weight: 600;
  }
}

.bg-success {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.bg-warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
}
</style>
